"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModelDescription = void 0;
// eslint-disable-next-line
function isModelDescription(arg) {
    // eslint-disable-next-line
    return arg && arg.class && (arg.func || arg.parameters);
}
exports.isModelDescription = isModelDescription;
//# sourceMappingURL=i-model-description.js.map